<script>
import { mapState } from 'vuex';

export default {
    name: "Header",
    data() {
        return {
            isShowMenu: false,
            menu: [
                {
                    icon: require('@/assets/images/icon_other_01.png'),
                    checked: require('@/assets/images/icon_other_01_checked.png'),
                },
                {
                    icon: require('@/assets/images/icon_other_02.png'),
                    checked: require('@/assets/images/icon_other_02_checked.png'),
                },
                {
                    icon: require('@/assets/images/icon_other_03.png'),
                    checked: require('@/assets/images/icon_other_03_checked.png'),
                },
                {
                    icon: require('@/assets/images/icon_other_04.png'),
                    checked: require('@/assets/images/icon_other_04_checked.png'),
                },
            ],
            menuActiveIndex: 0,
        };
    },
    computed: {
        ...mapState(['nav', 'isLogin', 'userinfo']),
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        '$route.path': function(){
            this.isShowMenu = false;
        },
    },
    methods: {},
};
</script>

<template>
    <div class="header">
        <div class="wrapper layout_main flex justify_end">
            <router-link class="logo" to="/"></router-link>
            <div class="content flex align_center">
                <div class="menu flex">
                    <div class="item" :class="{active: menuActiveIndex == index}" v-for="(item, index) in menu" :key="index">
                        <img :src="item.icon" alt="" class="icon"/>
                        <img :src="item.checked" alt="" class="icon checked"/>
                    </div>
                </div>
                <div class="username">{{ userinfo ? userinfo.name: '' }}</div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.header{
    background: var(--background-color);
    position: relative;
    z-index: 99;
    .wrapper{
        height: 1rem;
        position: relative;
        @media only screen and (max-width: 750px) {
            height: .9rem;
        }
    }
    .logo{
        position: absolute;
        top: 0;
        left: 0;
        width: 1.4rem;
        height: 1.19rem;
        background: url('~@/assets/images/logo.png') no-repeat 0/100%;
        @media only screen and (max-width: 750px) {
            width: 1.24rem;
            height: 1.08rem;
        }
    }
    .content{
        gap: .4rem;
        .username{
            font-size: .16rem;
            color: #fff;
        }
        .menu{
            .item{
                padding: 0 .3rem;
                border-right: 1px solid var(--color-blue);
                &:last-child{
                    border-right: 0;
                }
                &.active{
                    .icon{
                        display: none;
                        &.checked{
                            display: block;
                        }
                    }
                }
                .icon{
                    width: .32rem;
                    height: .32rem;
                    cursor: pointer;
                    &.checked{
                        display: none;
                    }
                }
            }
        }
    }
}
</style>